import SitesPage from './SitesPage';

export default SitesPage;
